// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__7rQmz","logo":"navbar_logo__JlRv8","links":"navbar_links__VAkee"};